import Immutable, {fromJS} from 'immutable';
import {
  REQUEST_TAG_LIST,
  RECEIVE_TAG_LIST,
  SET_TAGS_DASHBOARD_FILTERS,
} from './actions';
import {setNormalizedList} from 'app/utils/redux_v2';

const tagsArea = (
  state = Immutable.fromJS({
    isFetching: false,
    byId: {},
    queries: {},
    dashboard: {
      currentFilters: {},
    },
  }),
  action
) => {
  switch (action.type) {
    case REQUEST_TAG_LIST:
      return state.set('isFetching', true);

    case RECEIVE_TAG_LIST:
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );

    case SET_TAGS_DASHBOARD_FILTERS:
      return state
        .setIn(['dashboard', 'currentFilters'], fromJS(action.filters))
        .set('isFetching', true);

    default:
      return state;
  }
};

export default tagsArea;
